var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8867 3.15625H5.88672C4.78215 3.15625 3.88672 4.05168 3.88672 5.15625V19.1562C3.88672 20.2608 4.78215 21.1562 5.88672 21.1562H19.8867C20.9913 21.1562 21.8867 20.2608 21.8867 19.1562V5.15625C21.8867 4.05168 20.9913 3.15625 19.8867 3.15625Z",
    stroke: "#3D6B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88672 11.1562C10.9913 11.1562 11.8867 10.2608 11.8867 9.15625C11.8867 8.05168 10.9913 7.15625 9.88672 7.15625C8.78215 7.15625 7.88672 8.05168 7.88672 9.15625C7.88672 10.2608 8.78215 11.1562 9.88672 11.1562Z",
    stroke: "#3D6B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8867 15.1559L18.8007 12.0699C18.4257 11.695 17.917 11.4844 17.3867 11.4844C16.8564 11.4844 16.3478 11.695 15.9727 12.0699L6.88672 21.1559",
    stroke: "#3D6B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImageIcon);
export default __webpack_public_path__ + "static/media/BannerImageIcon.12b4efb6b0fb65fa99cbc5e5d5af1991.svg";
export { ForwardRef as ReactComponent };